exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".property-wrapper[data-v-5c1366f8]{background:#efecec}.sticky-footer .tab-pane[data-v-5c1366f8]{padding:15px}.sticky-footer .tab-pane[data-v-5c1366f8] .form-body{overflow-y:scroll;height:calc(var(--window-height, 100vh) - 273px)}@media (min-width:768px){.sticky-footer .tab-pane[data-v-5c1366f8] .form-body{height:calc(var(--window-height, 100vh) - 322px)}}.property-title[data-v-5c1366f8]{margin-top:.5rem}.return-to-stocklist-btn[data-v-5c1366f8]{min-width:116px}@media (max-width:767.98px){.property-title[data-v-5c1366f8]{margin-top:0;font-size:1rem;font-weight:700;margin-bottom:0}}", ""]);

// exports
